import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobInterviewsRoutingModule } from './job-interviews-routing.module';
import { HomeComponent } from './home/home.component';
import { SharedModule } from '../CustomWidget/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    NgbModule,
    JobInterviewsRoutingModule,
    SharedModule,
    RouterModule,
  ],
})
export class JobInterviewsModule {}
